// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\RecurringBatch\ApiRecurringBatchVersion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BatchRecurrencePeriod, BatchRecurrencePeriodData, BatchRecurrencePeriodOptions } from 'data/models/BatchRecurrencePeriod';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { RecurringBatchSelf, RecurringBatchSelfData, RecurringBatchSelfOptions } from 'data/models/RecurringBatchSelf';
import { RecurringBatchVersion as _RecurringBatchVersion, RecurringBatchVersionData as _RecurringBatchVersionData, RecurringBatchVersionOptions as _RecurringBatchVersionOptions } from 'data/models/RecurringBatchVersion';

// RecurringBatchVersionData is the class that RecurringBatchVersion serializes to/from
export interface RecurringBatchVersionData {
    ChangeId : number;
    Id : number;
	
    Change : ChangeData | null;
    EventsAbout : EventData[] | null;
    EventsReferencing : EventData[] | null;
    NextVersion : _RecurringBatchVersionData[] | null;
    PortId : number;
    PrevChange : ChangeData | null;
    PrevChangeId : number | null;
    PrevVersion : _RecurringBatchVersionData | null;
    Self : RecurringBatchSelfData | null;
	
    Deleted : boolean;
    Guid : /* GUID */ string;
    RecurrencePeriod : BatchRecurrencePeriodData;
    ReferenceNumber : string;
    RequestDate : /* ISO8601 */ string;
}

// RecurringBatchVersionOptions is the class which may be passed to the RecurringBatchVersion constructor to define optional initial data values
export interface RecurringBatchVersionOptions {
    ChangeId : number;
    Id : number;
	
    Change? : ChangeOptions | null;
    EventsAbout? : EventOptions[] | null;
    EventsReferencing? : EventOptions[] | null;
    NextVersion? : _RecurringBatchVersionOptions[] | null;
    PortId? : number;
    PrevChange? : ChangeOptions | null;
    PrevChangeId? : number | null;
    PrevVersion? : _RecurringBatchVersionOptions | null;
    Self? : RecurringBatchSelfOptions | null;
	
    Deleted? : boolean;
    Guid? : /* GUID */ string;
    RecurrencePeriod? : BatchRecurrencePeriodOptions;
    ReferenceNumber? : string;
    RequestDate? : /* ISO8601 */ string;
}

export class RecurringBatchVersion {
    public ChangeId : DataSignal<number>;
    public Id : DataSignal<number>;
	
    public Change : DataSignal<Change | null>;
    public EventsAbout : SDataArray<Event>;
    public EventsReferencing : SDataArray<Event>;
    public NextVersion : SDataArray<_RecurringBatchVersion>;
    public PortId : DataSignal<number>;
    public PrevChange : DataSignal<Change | null>;
    public PrevChangeId : DataSignal<number | null>;
    public PrevVersion : DataSignal<_RecurringBatchVersion | null>;
    public Self : DataSignal<RecurringBatchSelf | null>;
	
    public Deleted : DataSignal<boolean>;
    public Guid : DataSignal<string>;
    public RecurrencePeriod : BatchRecurrencePeriod;
    public ReferenceNumber : DataSignal<string>;
    public RequestDate : DataSignal<TZDate>;

    constructor();
    constructor(data : RecurringBatchVersionOptions);
    constructor(data: RecurringBatchVersionOptions | null = null) {
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Change = S.value<Change | null>(null);
        this.EventsAbout = SArray<Event>([]);
        this.EventsReferencing = SArray<Event>([]);
        this.NextVersion = SArray<_RecurringBatchVersion>([]);
        this.PortId = jsonableObservable(S.value<number>(data && data.PortId !== undefined ? data.PortId : 0));
        this.PrevChange = S.value<Change | null>(null);
        this.PrevChangeId = jsonableObservable(S.value<number | null>(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = S.value<_RecurringBatchVersion | null>(null);
        this.Self = S.value<RecurringBatchSelf | null>(null);
	    
        this.Deleted = jsonableObservable(S.value<boolean>(data && data.Deleted !== undefined ? data.Deleted : false));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.RecurrencePeriod = data && data.RecurrencePeriod !== undefined ? new BatchRecurrencePeriod(data.RecurrencePeriod) : new BatchRecurrencePeriod();
        this.ReferenceNumber = jsonableObservable(S.value<string>(data && data.ReferenceNumber !== undefined ? data.ReferenceNumber : ''));
        this.RequestDate = jsonableObservable(S.value<TZDate>(data && data.RequestDate !== undefined ? new TZDate(data.RequestDate) : new TZDate(0), TZDate.eq));
    }

    static key(obj : RecurringBatchVersion) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    }
    
    static dataKey(obj : RecurringBatchVersionOptions) {
        return obj.ChangeId + '\u2618' + obj.Id;
    }

    static update(obj : RecurringBatchVersion, data : RecurringBatchVersionOptions) {
        S.freeze(() => {
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.PortId !== undefined) obj.PortId(data.PortId);
            if (data.PrevChangeId !== undefined) obj.PrevChangeId(data.PrevChangeId);
	        
            if (data.Deleted !== undefined) obj.Deleted(data.Deleted);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.RecurrencePeriod !== undefined) BatchRecurrencePeriod.update(obj.RecurrencePeriod, data.RecurrencePeriod);
            if (data.ReferenceNumber !== undefined) obj.ReferenceNumber(data.ReferenceNumber);
            if (data.RequestDate !== undefined) obj.RequestDate(new TZDate(data.RequestDate));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/RecurringBatchVersion.ts